export default "__VITE_ASSET__QerrgLSt__"